// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"46d62461675ec90d","node_modules_dompurify_dist_purify_js":"90d5055390fbc5e2","node_modules_canvg_lib_index_es_js":"fa0040c4d0281eae"}[chunkId] + ".js";
};